function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 .5v5a.5.5 0 01-.5.5h-.29a.49.49 0 01-.36-.15l-1.64-1.64-5.36 5.35a.48.48 0 01-.7 0L8.5 6.91l-6.94 6.94a.5.5 0 01-.71 0l-.7-.7a.5.5 0 010-.71l8-8a.48.48 0 01.7 0l2.65 2.65 4.29-4.3-1.64-1.64A.49.49 0 0114 .79V.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5z"
});

var SvgTrendingUp = function SvgTrendingUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "#868E96"
  }, props), _ref);
};

export default SvgTrendingUp;